import styled from "styled-components";

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.h3`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
  color: #ffffff;
  line-height: 1.2;
  transition: color 0.3s ease;
`;


export const CardContainer = styled.div`
  position: relative;
  width: 340px;
  padding: 2.5rem 2rem;
  border-radius: 1.5rem;
  cursor: pointer;

  background: ${({ isSelected }) =>
    isSelected
      ? "linear-gradient(135deg, #3b2667 0%, #6b21a8 50%, #7c3aed 100%)"
      : "rgba(30, 30, 40, 0.85)"};

  color: #ffffff;

  border: ${({ isSelected }) =>
    isSelected
      ? "2px solid rgba(139, 92, 246, 0.5)"
      : "1px solid rgba(255, 255, 255, 0.08)"};

  box-shadow: ${({ isSelected }) =>
    isSelected
      ? "0 20px 40px rgba(139, 92, 246, 0.4), 0 0 0 1px rgba(139, 92, 246, 0.3)"
      : "0 4px 12px rgba(0, 0, 0, 0.3)"};

  transform: ${({ isSelected }) => (isSelected ? "translateY(-8px) scale(1.02)" : "translateY(0)")};
  
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: ${({ isSelected }) =>
    isSelected ? "translateY(-8px) scale(1.02)" : "translateY(-4px)"};
    box-shadow: ${({ isSelected }) =>
    isSelected
      ? "0 24px 48px rgba(139, 92, 246, 0.5), 0 0 0 1px rgba(139, 92, 246, 0.4)"
      : "0 8px 20px rgba(0, 0, 0, 0.4)"};
    border: ${({ isSelected }) =>
    isSelected
      ? "2px solid rgba(139, 92, 246, 0.6)"
      : "1px solid rgba(255, 255, 255, 0.15)"};
  }

  &:active {
    transform: ${({ isSelected }) =>
    isSelected ? "translateY(-6px) scale(1.01)" : "translateY(-2px)"};
  }
`;


export const CardText = styled.p`
  font-size: 0.9rem;
  font-weight: 400;
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
  transition: color 0.3s ease;
`;

export const FromText = styled.span`
  font-size: 0.9rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  display: block;
  margin-bottom: 0.5rem;
  line-height: 1;
  transition: color 0.3s ease;
`;
export const PriceText = styled.h2`
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  line-height: 1;
  letter-spacing: -0.02em;
  transition: color 0.3s ease;
`;



export const Features = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 400;
  line-height: 1.6;
  transition: color 0.3s ease;

  img {
    flex-shrink: 0;
    margin-top: 0.25rem;
    filter: brightness(0) invert(1);
    transition: filter 0.3s ease;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 1.5rem 0;
  transition: background 0.3s ease;
`;



export const CardButton = styled.button`
  width: 100%;
  padding: 0.875rem 1.5rem;
  border-radius: 0.75rem;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1rem;
  
  background: #ffffff;
  color: #51307F;
  
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(255, 255, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

//Source Card Styling
export const SourceItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.37rem;
  width: 9.1875rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: 1px solid rgba(235, 235, 253, 0.3);
  background: #f4f6f6;
  height: 3.5rem;
`;

export const SourceTxt = styled.div`
  color: #fff;
  font-family: Poppins;
  font-size: 0.6875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem; /* 150% */
`;

export const Popup = styled.div`
  position: absolute;
  top: -8.5rem;
  right: -3rem;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 10; /* Ensure the popup is above other content */
  padding: 0.5rem;
  width: 12rem; /* Adjust width as needed */
  border-radius: 0.5rem;
  display: ${(props) =>
    props.isOpen
      ? "block"
      : "none"}; /* Conditionally show/hide based on isOpen prop */
`;

export const PopupItem = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

//FileCard.jsx styling
export const FileBox = styled.div`
  position: relative;
  display: flex;
  width: 30%;
  padding: 0.625rem;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.75rem;
  background:  ${(props) => props.isPopup ? "#8B9AB1" : "rgba(0, 0, 0, 0.3)"};
  overflow: hidden;
`;

export const ImageDiv = styled.div`
  display: flex;
  padding:  ${(props) => props.isPopup ? "0.26244rem 0.375rem 0.30006rem 0.375rem" : "0.4375rem 0.625rem 0.5rem 0.625rem"};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: var(--Components-Input-Component-paddingBlockLG, 0.4375rem);
  background: #fff;
`;

export const FileName = styled.div`
  color: #ececec;
  font-family: Poppins;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem; /* 142.857% */
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflowed text */
  text-overflow: ellipsis; /* Show ellipsis for overflowed text */
  max-width: 100%; /* Ensure it respects the width of FileBox */
`;

export const FileType = styled.div`
  color:  ${(props) => props.isPopup ? "rgba(255, 255, 255, 0.65)" : "#8b9ab1"};
  font-family: "Segoe UI";
  font-size:  ${(props) => props.isPopup ? "0.625rem" : "0.8125rem"};
  font-style: normal;
  font-weight: 400;
  line-height:  ${(props) => props.isPopup ? "1rem" : "1.25rem"};
`;
